import { scrollTo } from '#components/generics/js/scroll/scrollTo.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { elements } from './../../../styles.js'

export const onClick = object(listener, {
  type: click,
  passive,
  task: (
    scrollButton
  ) => {
    const chat = scrollButton.closest(`.${elements.chat}`)
    const chatMessages = one(`.${elements.messages}`, chat)
    const { scrollHeight } = one(`.${elements.messages_in}`, chat)

    scrollTo(chatMessages, { top: scrollHeight })
  }
})

export default button => {
  onClick.listen(button)
}